// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"306a8c52","885":"65a1e923","977":"a5c2f382"}[chunkId] + ".chunk.js";
};